import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import React, { useRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import CreateEditPublicFeedbackBoard from "./createEditPublicFeedbackBoard";

const mapStateToProps = state => ({
    ...state
});

function CreatePublicFeedbackBoard(props)
{
    const backButtonRef = useRef(null);

    let goBack = () => {
        props.history.goBack();
    }

    return (<div>
        <div
            ref={backButtonRef}
            className="addPublicFeedbackButton"
            tabIndex={0}
            onClick={goBack}
            onKeyDown={(e) => { if (e.key === 'Enter') goBack(); }}
        >
            <ArrowBackIos />
            Back
        </div>

        <CreateEditPublicFeedbackBoard {...props} onCancelTab={() => backButtonRef.current?.focus()} />
    </div>);
}

export default withRouter(connect(mapStateToProps)(CreatePublicFeedbackBoard));